var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9907 11.5297C23.9909 9.48024 23.4194 7.46788 22.3351 5.70064C21.2509 3.9334 19.6933 2.47541 17.8234 1.47737C15.3958 0.126163 12.5324 -0.318832 9.78295 0.227849C9.46969 0.290325 9.13032 0.365296 8.85622 0.452762C6.313 1.11616 4.06825 2.56177 2.46788 4.56683C0.867514 6.57189 0.000342211 9.02512 0 11.5485V11.8234C0 12.2732 4.77982e-06 12.723 0.045689 13.1666C0.27411 15.5907 1.17474 17.8585 2.0819 20.1077C4.41024 25.7149 7.07078 31.1904 10.0505 36.5076C10.7032 37.6509 11.3166 38.7817 12.0084 40C12.1781 39.7189 12.3021 39.5252 12.4131 39.319C14.26 35.8516 16.1657 32.4092 17.9408 28.9043C20.0902 24.8032 21.8971 20.5457 23.3446 16.1717C23.8071 14.7571 24.0275 13.2803 23.9973 11.7984C23.9973 11.7047 23.9973 11.6172 23.9973 11.5235L23.9907 11.5297Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.676 2.90161L5.3253 13.9598H10.9118L7.93583 22.5315L18.7108 10.8485H13.3918L15.676 2.90161Z",
    fill: "#151E2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.4219,
    y1: -3.5,
    x2: 2.81967e-7,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22BACF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwlogo);
export default __webpack_public_path__ + "static/media/pwlogo.4d9f523b.svg";
export { ForwardRef as ReactComponent };